import REF from '~/services/REF'
import { AppThunk } from '~/state/store'
import ErrorHandler from '~/utils/errorHandler'

import { ROLES } from '~/constants/roles'

import { failure, requests, success } from './dashboard.slice'

/** `
 * Getting data for dashboard
 */
export const getDashboards = (): AppThunk<Promise<void>> => async (
  dispatch,
  getState
): Promise<void> => {
  dispatch(requests())

  const { role } = getState().user

  try {
    let resp: {
      [key: string]: any
    } = {}

    if (role === ROLES.clinic) {
      resp = await REF.getClinicDashboards()
    } else if (role === ROLES.image_center) {
      resp = await REF.getCenterDashboards()
    }

    dispatch(
      success({
        new_referrals: resp?.new_referrals.count,
        scheduled_referrals: resp?.scheduled_referrals.count,
        completed_referrals: resp?.completed_referrals.count,
        clinics_collection: resp?.clinics_collection?.count || 0
      })
    )
  } catch (error) {
    dispatch(failure(true))
    throw new ErrorHandler(error)
  }
}
